import {Component, EventEmitter, OnInit} from '@angular/core';
import {AbstractProdForm, ProdFormField, ProdFormFieldType} from 'prod-form';
import {OrganizationService} from "../../../services/organization.service";
import {OrganizationTreeSelect} from "../../../dip/organization-tree-select";
import {SelectedRecords} from 'prod-grid';
import {Role} from "../../../dip/role";
import {RoleService} from "../../../services/role.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-company-battery',
  templateUrl: './company-battery.component.html'
})
export class CompanyBatteryComponent extends AbstractProdForm implements OnInit {
  private isFieldsEditable: boolean = this.roleService.hasRole([Role.ROLE_COMPANY_EDIT]);
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'warningLimit',
      label: this.translate.instant('company.battery_settings.warning_limit'),
      type: ProdFormFieldType.NUMBER,
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'alertLimit',
      label: this.translate.instant('company.battery_settings.alert_limit'),
      type: ProdFormFieldType.NUMBER,
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'equipmentUnknownAfter',
      label: this.translate.instant('company.battery_settings.inactive_after'),
      type: ProdFormFieldType.NUMBER,
      isEditable: this.isFieldsEditable
    })
  ];
  records: SelectedRecords = new SelectedRecords();
  initializeFormEvent$: EventEmitter<void> = new EventEmitter<void>();
  style = {labelWidth: '200px'};

  constructor(override dataService: OrganizationService,
              private organizationTreeSelect: OrganizationTreeSelect,
              private roleService: RoleService,
              private translate: TranslateService) {
    super();
    organizationTreeSelect.formComponents.push(this);
  }

  ngOnInit(): void {
    this.records.toggle(this.organizationTreeSelect.company);
    this.data.records = this.records;
    this.data.formResponseEvent = new EventEmitter();
  }

  ngOnDestroy() {
    this.organizationTreeSelect.removeFormComponent(this);
  }
}
